var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / deforestation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "10.9286833 0.14744 21.857 0.14744 21.857 18.5668 0.000366666667 18.5668 0.000366666667 0.14744"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "11.2575786 5 0.519189062 5 0.519189062 0.485428571 11.2575786 0.485428571 11.2575786 5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Awards-&-Illustrations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-deforestation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(19.500000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8573667,10.78288 C21.8573667,9.57752 21.0631667,8.56748 19.9888333,8.27564 C19.7688333,7.40772 19.1271667,6.71612 18.3029,6.45544 C18.4217,6.15296 18.4884333,5.82312 18.4884333,5.47656 C18.4884333,4.04396 17.3671667,2.88192 15.9848333,2.88192 C15.5382333,2.88192 15.1202333,3.00428 14.7579667,3.21632 C14.3363,2.46544 13.5633667,1.95548 12.6716333,1.92736 C12.2734333,0.8854 11.2951667,0.14744 10.1482333,0.14744 C9.3225,0.14744 8.58476667,0.53048 8.08683333,1.1324 C7.9255,1.0982 7.7583,1.08072 7.5867,1.08072 C6.42216667,1.08072 5.4461,1.90608 5.1667,3.02176 C4.88216667,2.90624 4.57416667,2.84012 4.25076667,2.84012 C2.8677,2.84012 1.74716667,4.00216 1.74716667,5.43476 C1.74716667,5.50012 1.75156667,5.56396 1.75596667,5.6278 C0.7579,5.96904 0.0370333333,6.94184 0.0370333333,8.09096 C0.0370333333,9.36396 0.921433333,10.42036 2.08816667,10.64152 C1.90703333,10.963 1.79043333,11.3278 1.75816667,11.71768 C0.739566667,12.04676 0.000366666667,13.03172 0.000366666667,14.19528 C0.000366666667,15.62864 1.1209,16.78992 2.50396667,16.78992 C2.56116667,16.78992 2.6169,16.78536 2.67336667,16.78156 C3.0019,17.8182 3.94203333,18.5668 5.05156667,18.5668 C5.82303333,18.5668 6.51236667,18.20504 6.97143333,17.63656 C7.1797,17.68444 7.3953,17.71104 7.61823333,17.71104 C8.18803333,17.71104 8.71896667,17.54308 9.17216667,17.25656 C9.4215,17.34244 9.6877,17.39184 9.96563333,17.39184 C10.4320333,17.39184 10.8683667,17.25656 11.2423667,17.02552 C11.6017,17.33256 12.0615,17.51648 12.5631,17.51648 C13.2077,17.51648 13.7841,17.21248 14.1654333,16.73444 C14.4206333,16.80588 14.6868333,16.84692 14.9633,16.84692 C15.4854333,16.84692 15.9767667,16.71088 16.4079667,16.473 C16.8509,17.2026 17.6326333,17.689 18.5258333,17.689 C19.9089,17.689 21.0301667,16.52772 21.0301667,15.09436 C21.0301667,14.34956 20.7251,13.68 20.2403667,13.20728 C21.1849,12.83564 21.8573667,11.89172 21.8573667,10.78288",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(5.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.93515,3.88471429 C10.93515,3.88471429 10.51215,3.58257143 9.86865,3.61614286 C9.22515,3.64971429 8.79315,3.45685714 8.5464,3.29685714 C8.29965,3.13757143 8.22915,2.54971429 8.2464,2.27257143 C8.2644,1.99542857 8.3079,0.832571429 8.3079,0.832571429 L8.3889,0.752571429 C8.11365,0.876857143 7.80615,0.946857143 7.4814,0.946857143 C6.9684,0.946857143 6.4974,0.773285714 6.1299,0.485428571 C5.7474,0.701857143 5.3019,0.829 4.82415,0.829 C4.5504,0.829 4.2879,0.785428571 4.04115,0.709714286 L4.0059,0.803285714 C4.04115,1.02185714 4.06815,1.90328571 4.06815,1.90328571 C4.06815,1.90328571 4.0854,2.69257143 3.5214,3.01185714 C2.9574,3.33042857 1.56465,3.38971429 1.56465,3.38971429 C1.56465,3.38971429 0.60315,3.39757143 0.52665,4.16185714 C0.45015,4.92542857 0.98715,4.99971429 0.98715,4.99971429 L10.86465,4.99971429 C10.86465,4.99971429 11.1114,5.02685714 11.23515,4.60685714 C11.35815,4.18685714 10.93515,3.88471429 10.93515,3.88471429",
    id: "Fill-4",
    fill: "#000000",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "award---sorounding-icon",
    transform: "translate(12.000000, 12.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    rx: 8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForest);
export default __webpack_public_path__ + "static/media/Forest.cc846c47d03c57c5deb9f3a23709cb2f.svg";
export { ForwardRef as ReactComponent };